import React, { useState } from "react";
import { renderRichText, storyblokEditable } from "gatsby-source-storyblok"
import { Href } from "../utils/helper";
import * as styles from "./flightSection.module.css";


const FlightStatus = ({ blok }) => {
  // console.log(blok.statusTabs)

  const [activeTab, setActiveTab] = useState(0)
  return (
    <div className="my-10 mx-4 xl:max-w-[475px]">
      <div className="text-lg font-bold">{blok.statusTitle}</div>
      <>
        <div className="max-w-full">
          <div className="border-b border-b-black">
            <ul className="-mb-px flex items-center gap-4 text-sm font-medium">
              {blok.statusTabs?.map((item, i) => (
                <li key={i}>
                  <button onClick={() => setActiveTab(i)}
                    className={`inline-flex cursor-pointer items-center gap-2 sm:px-1 md:px-5 py-3 ${
                      activeTab === i ? 'relative text-primary-700 after:absolute after:left-0 after:bottom-0 after:h-1 after:w-full after:bg-[#C8D650]' : ''
                    }`}
                  >
                    {item.airline}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="py-4 px-4 relative">
            {blok.statusTabs?.map((item, i) => (
              <div className={activeTab === i ? 'block' : 'hidden'} {...storyblokEditable(item)} key={i} > 
                <div className="flex">
                  <a href={Href(item.bannerUrl)}><img className="max-w-full h-auto" loading="lazy" src={item.bannerImage?.filename} alt={item.bannerImage?.alt}/></a>
                  {
                  item.note && 
                  <span className="relative group">
                    <div role="tooltip" className="absolute right-4 group-hover:opacity-100 opacity-0 inline-block w-[240px] ml-1 px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm tooltip dark:bg-gray-700">
                      {item.note}
                    </div>
                    
                    <img className="inline w-4 h-4 ml-1 cursor-pointer" src="/icons/caution-red.svg" alt="caution"/>
                    
                  </span>
                  }
                </div>
                <div className={`${styles.statusTab} mb-6`} dangerouslySetInnerHTML={{ __html: renderRichText(item.statusText) }}>
                </div>
                {item.ctaImage && 
                <a href={Href(item.ctaUrl)} className="flex justify-cneter">
                  <img className="w-[400px] h-auto my-8" loading="lazy" src={item.ctaImage?.filename} alt={item.ctaImage?.alt}/>
                </a>
                }
              </div>
            ))}
          </div>
        </div>
      </>
      

    </div>
  );
};

export default FlightStatus;
